<div class="header-title">
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
            <a routerLink="/button" aria-label="back"
                class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
                <span class="u-icon icon-chevron-left"></span>
                <span class="u-button-text">Back</span>
            </a>
        </div>
        <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
            <h1 class="font-semibold u-ma-0 flex header-title--name">
                Grading Card
            </h1>
        </div>
    </div>
    <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
    <h2 id="CustomizedHeader" *ngIf="isBrowser">Customized Grading Card</h2>
    <div id="CustomizedTools" class="content__tools-wrap" *ngIf="isBrowser">
        <div class="content__row">
            <div class="c-input-check-inline">
                <input id="hasTitleName" class="c-input-check-inline__input" type="checkbox" name="hasTitleName"
                    [(ngModel)]="hasTitleName">
                <label for="hasTitleName" class="c-input-check-inline__label">Has Title Name</label>
            </div>
            <div class="c-input-check-inline">
                <input id="hasDate" class="c-input-check-inline__input" type="checkbox" name="hasDate"
                    [(ngModel)]="hasDate">
                <label for="hasDate" class="c-input-check-inline__label">Has Date</label>
            </div>
            <div class="c-input-check-inline">
                <input id="hasMetaData" class="c-input-check-inline__input" type="checkbox" name="hasMetaData"
                    [(ngModel)]="hasMetaData">
                <label for="hasMetaData" class="c-input-check-inline__label">Has Meta Data</label>
            </div>
            <div class="c-input-check-inline">
                <input id="hasLableIcon" class="c-input-check-inline__input" type="checkbox" name="hasLableIcon"
                    [(ngModel)]="hasLableIcon">
                <label for="hasLableIcon" class="c-input-check-inline__label">Has Lable Icon</label>
            </div>
            <div class="c-input-check-inline">
                <input id="hasPreviousAttempts" class="c-input-check-inline__input" type="checkbox" name="hasPreviousAttempts"
                    [(ngModel)]="hasPreviousAttempts">
                <label for="hasPreviousAttempts" class="c-input-check-inline__label">Has Previous Attempts</label>
            </div>
            <div class="c-input-check-inline">
                <input id="hasTooltip" class="c-input-check-inline__input" type="checkbox" name="hasTooltip"
                    [(ngModel)]="hasTooltip">
                <label for="hasTooltip" class="c-input-check-inline__label">Has Tooltip</label>
            </div>
            <div class="c-input-check-inline">
                <input id="hasGradeButton" class="c-input-check-inline__input" type="checkbox" name="hasGradeButton"
                    [(ngModel)]="hasGradeButton">
                <label for="hasGradeButton" class="c-input-check-inline__label">Has Grade Button</label>
            </div>
            <div class="c-input-check-inline">
                <input id="hasMoreActions" class="c-input-check-inline__input" type="checkbox" name="hasMoreActions"
                    [(ngModel)]="hasMoreActions">
                <label for="hasMoreActions" class="c-input-check-inline__label">Has More Actions</label>
            </div>
        </div>
        <div class="content__row">
            <input id="label" class="c-input-group__control" placeholder="Label" type="text" name="label"
                [(ngModel)]="label">
            <label for="label" class="u-display-none">label</label>
        </div>
    </div>
    <h2>Grading Card design view</h2>
    <maced-grading-card gradingCardId="gradingCardId">
        <ng-container ngProjectAs="[gradingCardDescription]">
            <maced-global-card cardId="sampleCard1" cardName="sampleCardName1">
                <div class="c-grading-card__header">
                    <div class="c-grading-card__header-block">
                        <div class="c-grading-card__header-block-tag" *ngIf="hasTitleName">
                            <maced-chip chipId="chipId" label="Tag name" [status]="selectedStatus" [size]="selectedSize"
                                [hasOutline]="hasOutline" [ariaLabel]="ariaLabel"></maced-chip>
                        </div>
                        <div class="c-grading-card__header-block-heading">            
                            <div class="c-grading-card__header-block-heading-title" [id]="label" >{{label}}</div>
                            <div class="c-grading-card__header-block-heading-date" id="date" *ngIf="hasDate"><label class="c-grading-card__header-block-heading-date-label">Date:</label>date</div>
                            <div class="c-grading-card__header-block-heading-sub-text" id="studentName"><span class="c-grading-card__header-block-heading-sub-text-value">Student username</span></div>
                        </div>
                        <div class="c-grading-card__header-block-metadata" id="metaData" *ngIf="hasMetaData">
                            <ng-container *ngIf="isMobileView;">
                                <maced-accordian-group accordianGroupId="accordianGroupId">
                                    <maced-accordian accordianId="accordianId1" [collapseLabel]="collapseLabel" [expandLabel]="expandLabel" [hasDefaultExpanded]="hasDefaultExpanded" [hasIconLeftSide]="hasIconLeftSide" [hasActions]="hasActions">
                                        <div ngProjectAs="[accordionContent]" class="c-grading-card__header-block-metadata__content">
                                            <ul class="c-grading-card__header-block-metadata-list" role="list">
                                                <li class="c-grading-card__header-block-metadata-list-item" *ngFor="let data of metaData; let index= index"  [id]="'metaData' + index" role="listitem">
                                                    <label class="c-grading-card__header-block-metadata-list-item-label">Course:</label>
                                                    <span class="c-grading-card__header-block-metadata-list-item-value" [id]="data + index">{{data}}</span>
                                                </li>
                                                <li class="c-grading-card__header-block-metadata-list-item" role="listitem">
                                                    <span class="c-grading-card__header-block-metadata-list-item-value">Teacher marked</span>
                                                    <em *ngIf="hasLableIcon" class="u-icon icon-clipboard-check c-grading-card__header-block-metadata-list-item-icon" title="clipboard icon" role="img" aria-label="clipboard icon"></em>
                                                </li>
                                            </ul>
                                        </div>
                                    </maced-accordian>
                                </maced-accordian-group>
                            </ng-container>
                            <ng-container *ngIf="isDesktopView;">
                                <div class="c-grading-card__header-block-metadata__content">
                                    <ul class="c-grading-card__header-block-metadata-list" role="list">
                                        <li class="c-grading-card__header-block-metadata-list-item" *ngFor="let data of metaData; let index= index"  [id]="'metaData' + index" role="listitem">
                                            <label class="c-grading-card__header-block-metadata-list-item-label">Course:</label>
                                            <span class="c-grading-card__header-block-metadata-list-item-value" [id]="data + index">{{data}}</span>
                                        </li>
                                        <li class="c-grading-card__header-block-metadata-list-item" role="listitem">
                                            <span class="c-grading-card__header-block-metadata-list-item-value">Teacher marked</span>
                                            <em *ngIf="hasLableIcon" class="u-icon icon-clipboard-check c-grading-card__header-block-metadata-list-item-icon" title="clipboard icon" role="img" aria-label="clipboard icon"></em>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="isDesktopView;">
                    <div class="c-grading-card__button-group">
                        <div class="c-grading-card__button-group-content">
                            <maced-button *ngIf="hasGradeButton" type="link" color="primary" buttonId="grade1" label="Grade"
                            position="left"></maced-button>
                            <maced-dropdown *ngIf="hasMoreActions" dropdownId="dropdownId4" name="dropdownId4"
                             ariaLabel="More Action Dropdown list navigate with tab" cheveronClass="icon-dots-vertical"
                                [options]="options4" dropdownText="Dropdown" label="More Actions">
                            </maced-dropdown>
                        </div>
                        <div class="c-grading-card__button-group-grading-count">
                            <em #tooltipTargetReference class="u-icon icon-info-circle c-grading-card__button-group-grading-count-icon c-grading-count--primary" [attr.role]="message?'img': ''" [attr.aria-label]="message" [attr.alt]="message"></em>
                            <maced-tooltip *ngIf="hasTooltip" id="tooltip1" [placement]="selectedPlacement" [hasCaret]="hasCaret"
                            [tooltipTargetReference]="tooltipTargetReference" [message]="message">
                            </maced-tooltip>
                            0 items require grading
                        </div>
                    </div>
                </ng-container>
                <div class="c-grading-card__body" *ngIf="hasPreviousAttempts">
                    <maced-accordian accordianId="accordianId2" [collapseLabel]="collapseLabel1"
                        [expandLabel]="expandLabel1" [hasContentBelow]="hasContentBelow" [hasDefaultExpanded]="hasDefaultExpanded"
                        [hasIconLeftSide]="hasIconLeftSide" [hasActions]="hasActions">
                        <div ngProjectAs="[accordionContent]" class="c-grading-card__attempt-cards">
                            <ul class="c-grading-card__attempt-cards-list" role="list">
                                <li class="c-grading-card__attempt-cards-list-item" *ngFor="let list of previousAttemptsData; let inx= index"  [id]="'PreviousAttempts'+ inx" role="listitem">
                                    <maced-global-card [cardId]="list.cardId" cardName="sampleCardName3">
                                        <div class="c-grading-card__attempt-block">
                                            <ul class="c-grading-card__attempt-block-list" role="list">
                                                <li class="c-grading-card__attempt-block-list-item" role="listitem">
                                                    <label class="c-grading-card__attempt-block-list-item-label">Attempts:</label>
                                                    <span class="c-grading-card__attempt-block-list-item-value" [id]="list.Attempts+ inx">{{list.Attempts}} </span>
                                                </li>
                                                <li class="c-grading-card__attempt-block-list-item" role="listitem">
                                                    <label class="c-grading-card__attempt-block-list-item-label">Attempted:</label>
                                                    <span class="c-grading-card__attempt-block-list-item-value" [id]="list.Attempted+ inx">{{list.Attempted}}</span>
                                                </li>
                                                <li class="c-grading-card__attempt-block-list-item" role="listitem">
                                                    <label class="c-grading-card__attempt-block-list-item-label">Score:</label>
                                                    <span class="c-grading-card__attempt-block-list-item-value" [id]="list.Score+ inx">{{list.Score}}</span>
                                                </li>
                                                <li class="c-grading-card__attempt-block-list-item" role="listitem">
                                                    <label class="c-grading-card__attempt-block-list-item-label">Graded by:</label>
                                                    <span class="c-grading-card__attempt-block-list-item-value" [id]="list.GradedBy+ inx">{{list.GradedBy}}</span>
                                                </li>
                                            </ul>
                                        </div>  
                                        <div class="c-grading-card__attempt-cards-list-item-buttons">                                  
                                            <maced-button  type="link" color="default" [buttonId]="list.buttonId+ 'mobile'" [ariaLabel]="list.GradedBy + ' View'" label="View" position="right" icon="icon-play"></maced-button>
                                        </div>  
                                    </maced-global-card>
                                </li>
                            </ul>
                        </div>
                    </maced-accordian>
                </div>
                <ng-container *ngIf="isMobileView;">
                    <div class="c-grading-card__button-group">
                        <div class="c-grading-card__button-group-content">
                            <maced-button *ngIf="hasGradeButton" type="link" color="primary" buttonId="grade2" label="Grade"
                            position="left"></maced-button>
                            <maced-dropdown *ngIf="hasMoreActions" dropdownId="dropdownId2" name="dropdownId2"
                                ariaLabel="Dropdown list with More Actions" cheveronClass="icon-dots-vertical"
                                [options]="options4" dropdownText="Dropdown" label="More Actions">
                            </maced-dropdown>
                        </div>
                        <div class="c-grading-card__button-group-grading-count">
                            <em #tooltipTargetReferenceMobile class="u-icon icon-info-circle c-grading-card__button-group-grading-count-icon c-grading-count--primary" [attr.role]="message?'img': ''" [attr.aria-label]="message" [attr.alt]="message"></em>
                            <maced-tooltip *ngIf="hasTooltip" id="tooltip2" [placement]="selectedPlacement" [hasCaret]="hasCaret"
                            [tooltipTargetReference]="tooltipTargetReferenceMobile" [message]="message">
                            </maced-tooltip>
                            0 items require grading
                        </div>
                    </div>
                </ng-container>
            </maced-global-card>
        </ng-container>
    </maced-grading-card>
</div>